import { Button, Typography } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { ArrowIcon, BreetIcon } from 'BreetAssets';
import { getTeamMemberRoleLabel } from 'BreetHelpers';
import { useFaviconApi } from 'BreetHooks';

import ImageComponent from '../ImageComponent';
import type { IAvailableAccount } from './DialogSwitchUserAccount.helpers';

const AvailableAccount = ({
	accountName,
	accountRole,
	onClick,
	isLoading,
	isActive,
	className,
	lastChild,
	websiteUrl,
}: IAvailableAccount) => {
	const { showFavicon, handleFaviconError, faviconUrl } = useFaviconApi(websiteUrl);

	return (
		<Button
			variant='native'
			className={classNameMerger(
				'switch-account-list-item bg-primary-400-hover',
				!lastChild && 'border-bottom-dark-navy',
				isActive && 'active',
				className
			)}
			onClick={onClick}
		>
			<div className='list-item-left'>
				{showFavicon ? (
					<ImageComponent
						src={faviconUrl}
						alt={`${accountName} logo`}
						className='logo-icon'
						width={32}
						height={32}
						onError={handleFaviconError}
					/>
				) : (
					<BreetIcon
						hideText
						className='logo-icon'
					/>
				)}
				<div className='list-item-txt'>
					<Typography
						as='h6'
						className='color-tertiary-400'
					>
						{accountName}
					</Typography>
					<Typography className='color-primary-50'>{getTeamMemberRoleLabel(accountRole)}</Typography>
				</div>
			</div>
			{isLoading && !isActive ? (
				<div className='button-spinner' />
			) : (
				<>
					{isActive ? (
						<span className='list-item-badge'>Current</span>
					) : (
						<ArrowIcon
							variant='arrowRight-available'
							className='svg-light'
						/>
					)}
				</>
			)}
		</Button>
	);
};

export default AvailableAccount;
